import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { UserProfileWrapper } from 'Components/Profiles';
import { ApiDocs as ApiDocsContent } from 'Containers/ApiDocs';

const UserApiDocsContainer = () => (
  <UserProfileWrapper tab="api-docs">
    <ApiDocsContent />
  </UserProfileWrapper>
);

const UserApiDocsContainerMemo = memo(UserApiDocsContainer, areEqual);

export { UserApiDocsContainerMemo as UserApiDocs };
